module.exports = __webpack_public_path__ + "static/img/img_5.60b5b175.jpg";